import mobx, { observable, action, computed, autorun } from 'mobx';
import api from '../../api';

export default class BetsPage {
	newDate = new Date();
	@observable dict = null;
	@observable bets = null;
	@observable isLoading = true;
	@observable wait = false;
	@observable filter = null;
	@observable date = {
		from: new Date(),
		to: new Date()
	}
	@observable regDate = '';
	@observable status = 0;
	@observable showDop = false;
	@observable result = {
		status: 0,
		text: '',
		type: 0
	};

	constructor(store, data) {
		this.store = store;
		// this.getData();
	}

	@action despose() {
		this.status = 0;
		this.bets = null;
		this.date = {
			from: new Date(),
			to: new Date()
		}
	}

	@action init() {
		this.getData()
	}

	@action getData() {
		return api.user.getBetsPeriodData().then(
			action(
				res => {
					if (res.code == 'OK') {
						this.filter = res.result;
						this.loadData();
					} else {
						this.setResult(res.text ? res.text : 'SERVER_TEMPORARILY_DOWN');
					}
				}
			)
		)
		.catch(action(err => {
      this.setResult('SERVER_TEMPORARILY_DOWN');
    }))
    .finally(action(() => { this.isLoading = false; }));
	}

	@computed get offset() {
		return new Date( new Date().getFullYear(),  new Date().getMonth() - (this.filter.month), 1);
	}

	@action selectDate(range) {
		this.date = range;
	}

	@action selectStatus(status) {
		this.status = status;
	}

	@action setResult(text, type = 0) {
		this.result.status = 1;
		this.result.text = text;
		this.result.type = type;
	}

	@action clear() {
		this.result.status = 0;
		this.result.text = '';
		this.result.type = 0;
	}

	@action loadData(from, to) {
		this.wait = true;
		this.clear();
		const data = {
			status : this.status,
			date_from : this.date.from.getTime(),
			date_to: this.date.to.getTime(),
		}
		return api.user.getBets(data).then(
				action(
					res => {
						if (res.code == 'OK') {
							this.dict = res.result.dict;
							this.addBets(res.result.bets);
							// if (!this.regDate) {
							// 	this.regDate = res.result.reg_date.split('-');
							// }
						} else {
							this.setResult(res.text ? res.text : 'SERVER_TEMPORARILY_DOWN');
						}
					}
				)
			)
			// .catch(action(err => {
   //      this.setResult('SERVER_TEMPORARILY_DOWN');
   //    }))
      .finally(action(() => { this.wait = false; }));
	}

	@action addBets(bets) {
		this.bets = bets.map(item => {
			if (item.games) {
				item.games = item.games.map( i => {
					i['sport_name'] = this.dict.sport[i.sid];
					i['league_name'] = this.dict.league[i.lid];
					i['event'] = `${this.dict.cmd[i.c1_id]}${i.c2_id ? ' - ' + this.dict.cmd[i.c2_id] : ''}`;
					i['name'] = this.dict.odd_bet[i.odd_id];
					return i;
				})

				return item;

			} else {
				return item;
			}
		})
	}

	@action cancel(id) {
		this.clear();
		const data = {
			action : 'cancel',
			id : id
		}
		return api.user.setCancel(data).then(
				action(
					res => {
						if (res.code == 'OK') {
							this.setResult(res.text, 1);
							const indx = this.data.findIndex(item => item == id);
							this.data[indx].allow_cancel = 0;
							this.data[indx].status = id;
						} else {
							this.setResult(res.text ? res.text : 'SERVER_TEMPORARILY_DOWN');
						}
					}
				)
			)
			.catch(action(err => {
        this.setResult('SERVER_TEMPORARILY_DOWN');
      }))
	}

}


// WEBPACK FOOTER //
// ./src/stores/accountStore/betsPeriod.js